import { render, staticRenderFns } from "./NavbarBrokerSelector.vue?vue&type=template&id=20bf1a53&"
import script from "./NavbarBrokerSelector.vue?vue&type=script&lang=js&"
export * from "./NavbarBrokerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports